__turbopack_context__.v({
  "blueSectionItem": "CTXyFa_blueSectionItem",
});
